import { memo, useEffect, useState } from "react";
import { useDebouncedCallback } from "use-debounce";

import { useAppSelector, useAppDispatch, setFooterContent, setHeaderContent } from "utils/store";

import { MiniTiptap } from "pages/tip-tap-editor";
import { saveTemplate } from "utils/api";
import { SidebarMenu } from "utils/ui";

import packageJson from "../../../../../package.json";

const MiniTipTapMemo = memo(MiniTiptap);

/**
 * Header & Footer settings (formerly "General Settings"). Holds only what repeats
 * on every page after the cover — header content, footer content, and the
 * automatic page numbers. Section-specific settings (e.g. the Contents title)
 * live on their own sections.
 */
const HeaderFooterSettings = () => {
  const dispatch = useAppDispatch();
  const headerInitContent = useAppSelector((state) => state.templateBuilderSlice.headerEditorInit);
  const footerInitContent = useAppSelector((state) => state.templateBuilderSlice.footerEditorInit);

  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    // hack to avoid tip tap editors from gaining focus and
    // autoscrolling the screen to undesired location
    setTimeout(() => {
      setIsReady(true);
    }, 50);
  }, []);

  const doDebouncedSave = useDebouncedCallback(async () => dispatch(saveTemplate()), 3000, {
    leading: false,
    trailing: true,
  });

  const onHeaderChange = (e: any) => {
    dispatch(setHeaderContent(e));
    doDebouncedSave();
  };

  const onFooterChange = (e: any) => {
    dispatch(setFooterContent(e));
    doDebouncedSave();
  };

  return (
    <div className="classy-scrollbar overflow-auto" style={{ maxHeight: "calc(80vh)" }}>
      <p className="mt-0">Set the header and footer content shown on every page after the cover page.</p>

      <SidebarMenu.Divider />

      {/** additional divs for optimising scrolling and screen jump */}
      <div style={{ minHeight: "300px" }}>
        <SidebarMenu.Heading title="Header Content" />
        <div style={{ display: isReady ? "" : "none" }}>
          <MiniTipTapMemo toolbarHeight={0} initialData={headerInitContent} onChange={onHeaderChange} />
        </div>
      </div>

      <div style={{ minHeight: "300px" }}>
        <SidebarMenu.Heading title="Footer Content" />
        <p>Page numbers are displayed automatically in the bottom left corner.</p>
        <div style={{ display: isReady ? "" : "none" }}>
          <MiniTipTapMemo toolbarHeight={0} initialData={footerInitContent} onChange={onFooterChange} />
        </div>
      </div>

      <div className="text-sm text-center mt-5">Version {packageJson.version}</div>
    </div>
  );
};

export default HeaderFooterSettings;
